<template>
  <v-container fluid class="admin-sasv-list">
    <v-row class="flex-grow-0">
      <v-col>
        <label class="text-h5">{{ $t('admin_sasv.title') }}</label>
      </v-col>
      <v-col class="text-right">
        <v-btn color="primary"
               class="mr-4"
               tile
               @click="massDisableModalShown = true">
          {{ $t('admin_sasv.mass_suspend_title') }}
        </v-btn>
        <v-btn color="primary"
               tile
               @click="refresh">
          <v-icon>fas fa-sync-alt</v-icon>
        </v-btn>
        <!--        <v-btn color="primary"-->
        <!--               @click="addMemberModalShown = true"-->
        <!--               v-if="$hasPermission('hkiarace.edit_member')">-->
        <!--          {{ $t('admin_user.add_user') }}-->
        <!--        </v-btn>-->
      </v-col>
    </v-row>
    <v-row class="flex-grow-1">
      <v-col class="pa-0">
        <SasvList full-height
                  :refresh-trigger.sync="refreshTrigger"
                  @edit="onSasvEdit"
                  @verify="onSasvValidate"></SasvList>
      </v-col>
    </v-row>

    <EditSasvModal :shown="editSasvModalShown"
                   :sasv-id="editingSasvId"
                   @cancel="editSasvModalShown = false"
                   @finish="onEditSasvModalFinish"></EditSasvModal>

<!--    <ValidateSasvModal :shown="validateSasvModalShown"-->
<!--                       :sasv-id="validatingSasvId"-->
<!--                       @cancel="validateSasvModalShown = false"-->
<!--                       @finish="onValidateSasvModalFinish"></ValidateSasvModal>-->

    <MassDisableSasvModal :shown="massDisableModalShown"
                          @cancel="onMassDisableModalFinish"></MassDisableSasvModal>
  </v-container>
</template>

<script>
import {ref} from '@vue/composition-api';
import SasvList from "@/components/sasv/SasvList";
import ValidateSasvModal from "@/components/sasv/ValidateSasvModal";
import EditSasvModal from "@/components/sasv/EditSasvModal";
import MassDisableSasvModal from "@/components/sasv/MassDisableSasvModal";

export default {
  name: 'ListSasv',
  components: {MassDisableSasvModal, EditSasvModal, ValidateSasvModal, SasvList},
  setup(props, {root}) {
    const refreshTrigger = ref(false);
    const refresh = function () {
      refreshTrigger.value = !refreshTrigger.value;
    };

    const exportUsers = function () {
      root.$callAPI('hkiarace/admin/user/export/', {}, function (response) {
        let blob = new Blob([response.data], {type: response.headers.get('content-type')});
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'users.xlsx';
        link.click();
      }, null, false, {responseType: 'arraybuffer'});
    };

    const massDisableModalShown = ref(false);
    const onMassDisableModalFinish = function () {
      massDisableModalShown.value = false;
      refresh();
    }

    const editingSasvId = ref(null);
    const editSasvModalShown = ref(false);
    const onSasvEdit = function (item) {
      editingSasvId.value = item.id;
      editSasvModalShown.value = true;
    };
    const onEditSasvModalFinish = function () {
      editSasvModalShown.value = false;
      refresh();
    }

    const validatingSasvId = ref(null);
    const validateSasvModalShown = ref(false);
    const onSasvValidate = async function (item) {
      const needRefresh = await root.$dialog.showAndWait(ValidateSasvModal, {
        showClose: false,
        width: '80vw',
        sasvId: item.id,
        persistent: true,
      });

      if (needRefresh) {
        refresh();
      }
    };
    const onValidateSasvModalFinish = function () {
      validateSasvModalShown.value = false;
      refresh();
    }

    return {
      refreshTrigger,
      refresh,

      exportUsers,

      massDisableModalShown,
      onMassDisableModalFinish,

      editingSasvId,
      editSasvModalShown,
      onSasvEdit,
      onEditSasvModalFinish,

      validatingSasvId,
      validateSasvModalShown,
      onSasvValidate,
      onValidateSasvModalFinish,
    }
  },
}
</script>

<style lang="less">
.admin-sasv-list {
  height: 100%;
  display: flex;
  flex-direction: column;

  .admin-member-main {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    padding-top: 10px;
    padding-bottom: 10px;
  }
}
</style>
